/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React from 'react';
import ExternalRedirect from 'Components/ExternalRedirect';
import { Redirect } from 'react-router-dom';
import sportsBookUtils from 'Utils/sportsBookUtils';
import EnvironmentManager from 'Utils/environmentManager';
import {
  SPORT_TYPE_BY_URL,
  POPULAR_BETS_TAB_PARAMS,
} from 'Store/constants/sportTypes';

import { GAME_TYPES } from 'Store/constants/externalGameTypes';

// Pages
import AsyncHome from 'Pages/Home';
import AsyncRegister from 'Pages/Register';
import AsyncLogin from 'Pages/Login';
import AsyncForgotPassword from 'Pages/ForgotPassword';
import AsyncNewPasswordWithEmail from './pages/ForgotPassword/AsyncNewPasswordWithEmail';
import AsyncNewPasswordWithPhoneNumber from './pages/ForgotPassword/AsyncNewPasswordWithPhoneNumber';
import AsyncSportsBook from 'Pages/SportsBook';
import AsyncTeamCard from 'Pages/TeamCard';
import AsyncLeagueCard from 'Pages/LeagueCard';
import AsyncLiveMatchTracker from 'Pages/LiveMatchTracker';
import AsyncLiveStream from 'Pages/LiveStream';
import AsyncLiveScores from 'Pages/LiveScores';
import AsyncCampaignDetail from 'Pages/CampaignDetail';
import AsyncFAQ from 'Pages/Help';
import AsyncNotFound from 'Pages/NotFound';
import AsyncRaffle from 'Pages/Raffle';
import AsyncExternalGame from 'Pages/ExternalGame';
import AsyncGameDetail from 'Pages/ExternalGame/GameDetail';
import AsyncTickets from 'Pages/ExternalGame/Tickets';
import AsyncStream from 'Pages/ExternalGame/Stream';
import AsyncTicketDetail from 'Pages/ExternalGame/TicketDetail';
import AsyncSporToto from 'Pages/SporToto';
import AsyncFinance from 'Pages/Account/Finance';
import AsyncSettings from 'Pages/Account/Settings';
import AsyncSuperSystem from 'Pages/SuperSystem';
import AsyncLogout from 'Pages/Logout';
import AsyncCoupons from 'Pages/Coupons';
import AsyncPersonalInformations from 'Pages/PersonalInformations';
import AsyncBestOfYear from 'Pages/BestOfYear';
import AsyncAnnouncementsList from 'Pages/AnnouncementsList';
import AsyncAnnouncementsDetail from 'Pages/AnnouncementsDetail';
import AsyncUserContract from 'Pages/UserContract';
import AsyncAbout from 'Pages/About';
import AsyncInformationSecurityPolicy from 'Pages/InformationSecurityPolicy';
import AsyncTribunV2 from 'Pages/TribunV2';
import AsyncPopularBets from 'Pages/PopularBets';
import AsyncAllCategories from 'Pages/AllCategories';
import AsyncSocialCoupon from 'Pages/SocialCoupon';
import AsyncSporTotoSocialCoupon from 'Pages/SporTotoSocialCoupon';
import AsyncKVKKContactUs from 'Pages/KVKKContactUs';
import AsyncThrowbackCoupon from 'Pages/ThrowbackCoupon';
import AsyncVerifyEmail from 'Pages/VerifyEmail';
import AsyncMobileApps from 'Pages/MobileApps';
import AsyncCommunicationCancelation from 'Pages/CommunicationCancelation';
import AsyncPauseMembership from 'Pages/PauseMembership';
import AsyncCancelMembership from 'Pages/CancelMembership';
import UndefinedDeepLink from 'Pages/UndefinedDeepLink';
import AsyncStaticCmsPage from 'Pages/StaticCmsPage';
import AsyncStaticPage, { loadData as loadStaticPageData } from 'Pages/StaticPage';
import AsyncRaffleLayout from 'Pages/RaffleV2';
import AsyncWorldCup from './pages/WorldCup';
import AsyncAuthors from './pages/Authors';
import AsyncScratchCardLayout from 'Pages/ScratchCard';
import AsyncPersonalizationTerms from 'Pages/Personalization';
import AsyncMultipleLMT from './pages/MultipleLMT';
import AsyncInviteFriend from 'Pages/InviteFriend';
import AsyncInviteFriendAuth from 'Pages/InviteFriendAuth';
import AsyncBetSlip from 'Pages/BetSlip';
import qs from 'query-string';
import AsyncKVKK from 'Pages/KVKK';
import AsyncTag from './pages/Tag';
import AsyncLeagueCenter from './pages/LeagueCenter';
import AsyncWorldCupNostalgia from './pages/WorldCupNostalgia';
import AsyncLowBalance from 'Pages/LowBalance';
//import AsyncEuro2024 from './pages/Euro2024';
import AsyncCouponOrder from './pages/CouponOrder';
import AsyncVaixSearch from './pages/VaixSearch';
import AsyncCouponSuccess from './pages/CouponSuccess';
import AsyncHelp from './pages/ExternalGame/Help';
import AsyncCouponFetch from './pages/CouponFetch';
import AsyncMailPrivacyPolicy from './pages/MailPrivacyPolicy';
import AsyncPlatformPrivacyPolicy from './pages/PlatformPrivacyPolicy';
import AsyncMatchCardRouter, { loadData as loadMatchCardData } from './pages/MatchCard';
import AsyncPendingMembershipScreen from 'Pages/PendingMembershipScreen';
import AsyncPendingDepositMoney from 'Pages/PendingDepositMoney';
import AsyncHorseRacing from 'Pages/HorseRacing';
import AsyncReportedSuspendedJockeys from 'Pages/ReportedSuspendedJockeys';


export default [
  {
    path: '/',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncHome { ...props } />,
    loadData: () => [
      // actions.getMainSliderData(),
      // actions.getCampaignsData(),
    ]
  },
  {
    path: '/uye-ol',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncRegister { ...props } />
  },
  {
    path: '/giris-yap',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncLogin { ...props } />
  },
  {
    path: '/sifremi-unuttum',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncForgotPassword { ...props } />
  },
  {
    path: '/sifremi-unuttum/telefon-ile/yeni-sifre-belirleme',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncNewPasswordWithPhoneNumber { ...props } />
  },
  {
    path: '/sifremi-unuttum/email-ile/yeni-sifre-belirleme/:token',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncNewPasswordWithEmail { ...props } />
  },
  {
    path: '/iddaa/populer-bahisler/:subTabName?',
    // eslint-disable-next-line react/display-name
    // eslint-disable-next-line no-nested-ternary
    render: props =>(SPORT_TYPE_BY_URL[props.match.params.subTabName] || !props.match.params.subTabName) && props.match.params.subTabName !== 'futbol'  ? <AsyncPopularBets { ...props } />
      : (SPORT_TYPE_BY_URL[props.match.params.subTabName] ? <Redirect replace to='/iddaa/populer-bahisler'/> : <AsyncNotFound { ...props } />)
  },
  {
    path: ['/spor-toto/kupon/:couponId?'],
    // eslint-disable-next-line react/display-name
    render: props => <AsyncSporTotoSocialCoupon { ...props } />
  },
  {
    path: ['/iddaa/kupon/:couponId?'],
    // eslint-disable-next-line react/display-name
    render: props => <AsyncSocialCoupon { ...props } />
  },
  {
    path: '/iddaa/:tabName/:subTabName',
    // eslint-disable-next-line react/display-name
    // eslint-disable-next-line no-nested-ternary
    render: props => ([POPULAR_BETS_TAB_PARAMS.POPULAR, POPULAR_BETS_TAB_PARAMS.TRENDING, POPULAR_BETS_TAB_PARAMS.RECOMMENDED].includes(props.match.params.tabName))
    && ['canli', 'yakinda-baslayacak'].includes(props.match.params.subTabName) ? <AsyncPopularBets { ...props } /> : <AsyncNotFound { ...props } />
  },
  {
    path: ['/iddaa/:sportType?', '/canli-iddaa/:sportType?', '/iddaa'],
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => {
      const isValidUrl = sportsBookUtils.isValidUrl(
        props.history.location.pathname
      );

      if (!isValidUrl) {
        return <AsyncNotFound { ...props } />;
      }

      return <AsyncSportsBook { ...props } />;
    }
  },
  {
    path: ['/tarihte-bugun', '/tarihte-bugun/:couponId?'],
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncThrowbackCoupon { ...props } />
  },
  // {
  //   path: '/mac-karti/:sportType/:eventId/:tabName?/:tabId?',
  //   // eslint-disable-next-line react/display-name
  //   render: props =>props.match.isExact && SPORT_TYPE_BY_URL[props.match.params.sportType] && !isNaN(props.match.params.eventId)
  //   && (!props.match.params.tabName || ['oranlar', 'kupon-emri', 'detay', 'onemli-anlar', 'canli-istatistikler', 'puan-durumu', 'kadro', 'akilli-analiz', 'karsilastirma', 'kuponlar', 'istatistikler',
  //     'form', 'bahis-istatistikleri', 'alt-ust-istatistikleri', 'mac-detay', 'yazarlar', 'kuponlar', 'puan-durumu-matrisi', 'ilk-11ler', 'sakat-cezali', 'hakem-istatistikleri', 'seriler', 'dunya-siralamasi', 'tribun', 'oyuncu-analizi', 'sicak-bahisler', 'oyuncu-istatistikleri'].includes(props.match.params.tabName)) ? <AsyncMatchCard { ...props } /> : <AsyncNotFound { ...props } />
  // },
  {
    path: '/mac-karti/:sportType/:eventId/:tabName?/:tabId?',
    // eslint-disable-next-line react/display-name
    render: props =>props.match.isExact && SPORT_TYPE_BY_URL[props.match.params.sportType] && !isNaN(props.match.params.eventId)
    && (!props.match.params.tabName || ['oranlar', 'kupon-emri', 'detay', 'onemli-anlar', 'canli-istatistikler', 'puan-durumu', 'kadro', 'akilli-analiz', 'karsilastirma', 'kuponlar', 'istatistikler',
      'form', 'bahis-istatistikleri', 'alt-ust-istatistikleri', 'mac-detay', 'yazarlar', 'kuponlar', 'puan-durumu-matrisi', 'ilk-11ler', 'sakat-cezali', 'hakem-istatistikleri', 'seriler', 'dunya-siralamasi', 'tribun', 'oyuncu-analizi', 'sicak-bahisler', 'oyuncu-istatistikleri', 'eslesmeler',
      'duello-ev', 'duello-deplasman', 'tahminler', 'istatistik', 'bahista', 'bahista-yapay-zeka-iddaa-tahminleri'].includes(props.match.params.tabName)) ? <AsyncMatchCardRouter { ...props } /> : <AsyncNotFound { ...props } />,
    loadData: loadMatchCardData,
  },
  {
    path: '/takim-karti/:eventId/:side/:tabName',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncTeamCard { ...props } />
  },
  {
    path: '/lig-karti/:sportType/:leagueId/:tabName/:isNBA?',
    // eslint-disable-next-line react/display-name
    render: props =>SPORT_TYPE_BY_URL[props.match.params.sportType] && !isNaN(props.match.params.leagueId) && ['puan-durumu', 'form-durumu', 'fikstur'].includes(props.match.params.tabName)
      ? <AsyncLeagueCard { ...props } /> : <AsyncNotFound { ...props } />
  },
  {
    path: '/canli-anlatim/:sportType/:betRadarId',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncLiveMatchTracker { ...props } />
  },
  {
    path: '/canli-mac-izle/:tabName?',
    // eslint-disable-next-line react/display-name
    render: props => {
      const isSSR = typeof window === 'undefined';
      const validTabNames = ['canli-futbol-izle', 'canli-basketbol-izle', 'canli-voleybol-izle', 'canli-hentbol-izle', 'canli-motor-sporlari-izle', 'canli-tenis-izle', 'canli-snooker-izle', 'canli-masa-tenisi-izle', 'canli-buz-hokeyi-izle', 'canli-e-futbol-izle', 'canli-e-basketbol-izle'];

      if (!props.match.params.tabName || validTabNames.includes(props.match.params.tabName)) {
        if (isSSR) {
          return <></>;
        }
        return <AsyncLiveStream { ...props } />;
      } else {
        return <AsyncNotFound { ...props } />;
      }
    }
  },
  {
    path: '/canli-skor/:tabName?',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props =>(!props.match.params.tabName || ['takip-ettiklerim', 'basketbol-canli-skor', 'tenis-canli-skor', 'voleybol-canli-skor', 'buz-hokeyi-canli-skor', 'kuponumdakiler'].includes(props.match.params.tabName)) ? <AsyncLiveScores { ...props } /> : <AsyncNotFound { ...props } />
  },
  {
    path: '/kampanyalar/:campaignId?/:tabName?',
    // eslint-disable-next-line react/display-name
    render: props =>!props.match.params.campaignId || !isNaN(props.match.params.campaignId) ? <AsyncCampaignDetail { ...props } /> :  <AsyncNotFound { ...props } />
  },
  {
    path: '/bahis-ekle',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncBetSlip { ...props } />
  },

  {
    path: '/carkifelek/:Id',
    // eslint-disable-next-line react/display-name
    render: props => <UndefinedDeepLink { ...props } />
  },
  {
    path: '/bilyoner/:tabName?',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncStaticCmsPage { ...props } />
  },
  {
    path: '/aydinlatma-metinleri/:slug',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncStaticPage { ...props } />,
    loadData: loadStaticPageData
  },
  {
    path: '/yardim/:helpType?/:faqType?',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncFAQ { ...props } />
  },
  {
    path: '/hesabim/:linkName?/:subLinkName?/:thirdLinkName?',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncFinance { ...props } />
  },
  {
    path: '/ayarlar/:linkName?',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncSettings { ...props } />
  },
  {
    path: '/super-sistem',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncSuperSystem { ...props } />
  },
  {
    path: '/spor-toto/:tabName?',
    // eslint-disable-next-line react/display-name
    render: props =>(props.match.isExact &&  (!props.match.params.tabName || ['kuponlarim', 'sonuclar'].includes(props.match.params.tabName))) ? <AsyncSporToto { ...props } /> : <AsyncNotFound { ...props } />
  },
  {
    path: '/kuponlarim/:couponType?/:tabName?',
    // eslint-disable-next-line react/display-name
    render: props =>(!props.match.params.couponType || !props.match.params.tabName)
    || (((props.match.params.couponType === 'iddaa' || props.match.params.couponType === 'uzun-vadeli') && ['devam-eden', 'kazanan', 'kaybeden', 'kayitli', 'onaylanmayan'].includes(props.match.params.tabName))
      || (props.match.params.couponType === 'spor-toto' && ['devam-eden', 'kazanan', 'kaybeden', 'kayitli'].includes(props.match.params.tabName))
      || (props.match.params.couponType === 'tjk' && ['devam-eden', 'kazanan', 'kaybeden', 'kayitli'].includes(props.match.params.tabName)))  ? <AsyncCoupons { ...props } /> : <AsyncNotFound { ...props } />
  },
  {
    path: '/cikis-yap',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncLogout { ...props } />
  },
  {
    path: '/kisisel-bilgilerim/:linkName?',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncPersonalInformations { ...props } />
  },
  {
    path: '/yilin-enleri',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncBestOfYear { ...props } />
  },
  {
    path: '/duyurular',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncAnnouncementsList { ...props } />
  },
  {
    path: '/duyurular/:announcementId',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncAnnouncementsDetail { ...props } />
  },
  {
    path: '/uyelik-sozlesmesi',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncUserContract { ...props } />,
  },
  {
    path: ['/gizlilik', '/cerez-tercihleri-aydinlatma-metni', '/kvkk'],
    // eslint-disable-next-line react/display-name
    render: props => <AsyncKVKK { ...props } />,
  },
  {
    path: '/kvkk-bize-yazin',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncKVKKContactUs { ...props } />,
  },
  {
    path: '/kunye',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncTag { ...props } />,
  },
  {
    path: '/hakkimizda',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncAbout { ...props } />,
  },
  {
    path: '/bilgi-guvenligi-politikasi',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncInformationSecurityPolicy { ...props } />,
  },
  {
    path: '/milli-piyango',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncExternalGame { ...props } type={ GAME_TYPES.MP }  />,
  },
  {
    path: '/milli-piyango/biletlerim',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncTickets { ...props } type={ GAME_TYPES.MP } />,
  },
  {
    path: '/milli-piyango/canli-cekilis-izle',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncStream { ...props } />,
  },
  {
    path: '/milli-piyango/biletlerim/detay/:gameType?/:couponId?',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncTicketDetail { ...props }  />,
  },
  {
    path: '/milli-piyango/:game?',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncGameDetail { ...props } type={ GAME_TYPES.MP } />,
  },
  {
    path: '/kazi-kazan',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncExternalGame { ...props } type={ GAME_TYPES.SCRATCH_CARD } />,
  },
  {
    path: '/kazi-kazan/:game?',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncGameDetail { ...props } type={ GAME_TYPES.SCRATCH_CARD }  />,
  },
  {
    path: '/sanal-bahis',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncExternalGame { ...props } type={ GAME_TYPES.VIRTUAL_BET } />,
  },
  {
    path: '/sanal-bahis/:game?',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncGameDetail { ...props } type={ GAME_TYPES.VIRTUAL_BET } />,
  },
  {
    path: '/sanal-yaris',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncExternalGame { ...props } type={ GAME_TYPES.VIRTUAL_HORSE_RACE } />,
  },
  {
    path: '/sanal-yaris/:game?',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncGameDetail { ...props } type={ GAME_TYPES.VIRTUAL_HORSE_RACE } />,
  },
  {
    path: '/bas-kazan',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncExternalGame { ...props } type={ GAME_TYPES.INTERACTIVE_GAMES } />,
  },
  {
    path: '/bas-kazan/:game?',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncGameDetail { ...props } type={ GAME_TYPES.INTERACTIVE_GAMES }  />,
  },
  {
    path: '/tribun',
    // exact: true,
    // eslint-disable-next-line react/display-name,
    render: props => <AsyncTribunV2 { ...props } />,
  },
  {
    path: '/tum-kategoriler',
    // exact: true,
    // eslint-disable-next-line react/display-name,
    render: props => <AsyncAllCategories { ...props } />,
  },
  {
    path: '/milli-mucadele-arac-cekilisi',
    // exact: true,
    // eslint-disable-next-line react/display-name,
    render: props => <AsyncRaffle { ...props } />
  },
  {
    path: '/bilgi-toplumu-hizmetleri',
    // eslint-disable-next-line react/display-name
    render: props => <ExternalRedirect { ...props } link='https://e-sirket.mkk.com.tr/esir/Dashboard.jsp#/sirketbilgileri/14628' />,
  },
  {
    path: '/verify-code/:token',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncVerifyEmail { ...props } />,
  },
  {
    path: '/dunya-kupasi',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncWorldCup { ...props } />,
  },
  {
    path: '/euro2024',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncHome { ...props } />,
  },
  {
    path: '/kupon-emri',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncCouponOrder { ...props } />,
  },

  {
    path: '/kupon-getir',
    render: props => {
      if (typeof window === 'undefined') {
        return <></>;
      }
      const value = EnvironmentManager.getMessageText({ key: 'coupon_suggestion_toggle' });

      if (value == null || value === undefined) {
        return <></>;
      }

      const isEnabled = value === true || value === 'true';

      return isEnabled
        ? <AsyncCouponFetch { ...props } />
        : <AsyncNotFound { ...props } />;
    },
  },

  {
    path: '/yazarlar/yazar-detay/:user?',
    render: props => {
      const isSSR = typeof window === 'undefined';
      const lastSegment = props.location.pathname.split('/').pop();
      const isLastSegmentNumber = (/\d+/).test(lastSegment);
      if (
        props.location.pathname.startsWith('/yazarlar/yazar-detay/')
        && isLastSegmentNumber
      ) {
        if (isSSR) {
          return <></>;
        }
        return <AsyncAuthors { ...props } page={ 'yazar-detay' } />;
      } else {
        return <AsyncNotFound { ...props } />;
      }
    },
    loadData: () => {
      return [];
    }
  },
  {
    path: '/yazarlar/:tabName?',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncAuthors { ...props } page="yazarlar"/>
  },
  {
    path: '/email-reset-password/:token',
    // eslint-disable-next-line react/display-name
    render: props => props.match.params.token ? <Redirect push to={ `/sifremi-unuttum/email-ile/yeni-sifre-belirleme/${props.match.params.token}` } /> : <Redirect push to='/'/>
  },
  {
    path: '/indir',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncMobileApps { ...props } />,
  },
  {
    path: '/e-posta-abonelik/:ecid?',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncCommunicationCancelation { ...props } />
  },
  {
    path: ['/cerez-ayarlari', '/cerez-ayarlari/cerez-tercihleri', '/cerez-ayarlari/cerez-aydinlatmasi', '/cerez-ayarlari/internet-sitesi-aydinlatmasi'],
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncHome { ...props }  />
  },
  {
    path: '/sans-oyunlari',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncExternalGame { ...props } type={ GAME_TYPES.CHANCE_GAMES }/>,
  },
  {
    path: '/sans-oyunlari/yardim/:game?',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncHelp { ...props } type={ GAME_TYPES.CHANCE_GAMES } />,
  },
  {
    path: ['/sans-oyunlari/esya-piyangosu', '/sans-oyunlari/esya-piyangosu/biletlerim', '/sans-oyunlari/esya-piyangosu/cekilis-sonuclari'],
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncRaffleLayout page="cekilis"  { ...props } />,
  },
  {
    path: '/sans-oyunlari/esya-piyangosu/bilet-detay/:ticketId?',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncRaffleLayout page="bilet-detay" { ...props } />,
  },
  {
    path: ['/sans-oyunlari/oyna-kazan', '/sans-oyunlari/oyna-kazan/kartlarim', '/sans-oyunlari/oyna-kazan/kartlarim/kazanan', '/sans-oyunlari/oyna-kazan/kartlarim/kaybeden', '/sans-oyunlari/oyna-kazan/kurallar'],
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => (
      <AsyncScratchCardLayout page="oyna-kazan"  { ...props } />
    ),
  },
  {
    path: ['/sans-oyunlari/oyna-kazan/kart', '/sans-oyunlari/oyna-kazan/detay'],
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => (
      <AsyncScratchCardLayout page="kart" { ...props } />
    ),
  },
  {
    path: '/sans-oyunlari/oyna-kazan/tebrikler',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => (
      /*<DigitalGamesAgreementGuard redirectPath="/sans-oyunlari" latestVersion={ props.latestAgreementVersion }>
        <AsyncScratchCardLayout page="tebrikler" { ...props } />
      </DigitalGamesAgreementGuard>*/
      <AsyncScratchCardLayout page="tebrikler" { ...props } />
    ),
  },
  {
    path: '/sans-oyunlari/:game?',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncGameDetail { ...props } type={ GAME_TYPES.CHANCE_GAMES } />,
  },

  {
    path: '/sans-oyunlari/esya-piyangosu/iletisim-izinleri',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncRaffleLayout page="iletisim-izinleri" { ...props } />,
  },
  {
    path: '/sans-oyunlari/esya-piyangosu/detay/:raffleName',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncRaffleLayout page="detay" { ...props } />,
  },

  // #region real-tjk
  {
    path: '/tjk',
    exact: true,
    render: props => <AsyncHorseRacing page="at-yarisi-anasayfa" { ...props } />,
  },
  {
    path: ['/tjk/at-yarisi-bulteni', '/tjk/at-yarisi-bulteni/:hippodrome?-at-yarisi-bulteni'],
    exact: true,
    render: props => <AsyncHorseRacing page="at-yarisi-bulteni" { ...props } />,
  },
  {
    path: ['/tjk/sabit-ihtimalli-at-yarisi-bulteni', '/tjk/sabit-ihtimalli-at-yarisi-bulteni/:hippodrome?-at-yarisi-bulteni'],
    exact: true,
    render: props => <AsyncHorseRacing page="sabit-ihtimalli-at-yarisi-bulteni" { ...props } />,
  },
  {
    path: '/tjk/at-yarisi-sonuclari',
    exact: true,
    render: props => <AsyncHorseRacing page="at-yarisi-sonuclari" { ...props } />,
  },
  {
    path: '/tjk/at-yarisi-sonuclari/:hippodrome?-at-yarisi-sonuclari/:raceNumber?',
    exact: true,
    render: props => <AsyncHorseRacing page="at-yarisi-sonuclari" { ...props } />,
  },
  {
    path: '/tjk/muhtemeller',
    exact: true,
    render: props => <AsyncHorseRacing page="muhtemeller" { ...props } />,
  },
  {
    path: '/tjk/agf-tablosu',
    exact: true,
    render: props => <AsyncHorseRacing page="agf-tablosu" { ...props } />,
  },
  {
    path: '/tjk/agf-tablosu/:hippodrome?-agf-tablosu',
    exact: true,
    render: props => <AsyncHorseRacing page="agf-tablosu" { ...props } />,
  },
  {
    path: '/tjk/yaklasan-kosular',
    exact: true,
    render: props => <AsyncHorseRacing page="yaklasan-kosular" { ...props } />,
  },
  {
    path: '/tjk/raporlu-cezali-jokeyler',
    exact: true,
    render: props => <AsyncReportedSuspendedJockeys page="raporlu-cezali-jokeyler" { ...props } />
  },
  {
    path: '/tjk/at-yarisi-kuponlarim/:couponId?',
    exact: true,
    render: props => <AsyncHorseRacing page="at-yarisi-kuponlarim" { ...props } />,
  },
  {
    path: '/tjk/at-yarisi/kupon-paylas/:couponId?',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncHorseRacing page="paylasilan-kupon" { ...props } />,
  },
  {
    path: '/tjk/sabit-ihtimalli-at-yarisi/kupon-paylas/:couponId?',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncHorseRacing page="paylasilan-sabit-ihtimalli-kupon" { ...props } />,
  },
  {
    path: '/tjk/kupon-paylas/:couponId?',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncHorseRacing page="kupon-paylas" { ...props } />,
  },
  {
    path: '/tjk/sabit-ihtimalli-kupon-paylas/:couponId?',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncHorseRacing page="sabit-ihtimalli-kupon-paylas" { ...props } />,
  },
  /* {
    path: '/tjk/kupon-paylas/:couponId?',
    exact: true,
    render: props => renderHorseRacingPage(AsyncHorseRacing, 'kupon-paylas', props),
  },
  {
    path: '/tjk/at-yarisi/kupon-paylas/:couponId?',
    exact: true,
    render: props => renderHorseRacingPage(AsyncHorseRacing, 'paylasilan-kupon', props),
  },*/
  {
    path: '/tjk/at-yarisi-tahminleri/:author?',
    exact: true,
    render: props => <AsyncHorseRacing page="at-yarisi-tahminleri" { ...props } />,
  },
  {
    path: '/tjk/at-karti/:widget?',
    exact: true,
    render: props => <AsyncHorseRacing page="at-karti" { ...props } />,
  },
  {
    path: '/tjk/yaris-detay',
    exact: true,
    render: props => <AsyncHorseRacing page="yaris-detay" { ...props } />,
  },
  {
    path: '/tjk/tjk-tv-canli-izle',
    exact: true,
    render: props => <AsyncHorseRacing page="tjk-tv" { ...props } />,
  },
  {
    path: '/tjk/tjk-tv-yurtdisi-izle',
    exact: true,
    render: props => <AsyncHorseRacing page="tjk-tv-yurtdisi" { ...props } />,
  },
  // #endregion

  {
    path: '/kisisellestirme-aydinlatma-metni',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncPersonalizationTerms { ...props } />,
  },
  {
    path: '/ara-verme/:token',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncPauseMembership { ...props } />,
  },
  {
    path: '/iptal/:token',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncCancelMembership { ...props } />,
  },
  {
    path: '/coklu-mac-takibi/:sportType?',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncMultipleLMT { ...props } />
  },
  {
    path: '/dunya-kupasi-nostalji',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncWorldCupNostalgia { ...props } />
  },
  {
    path: '/lig-merkezi',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncLeagueCenter { ...props } />
  },
  {
    path: '/lig-merkezi/:mainSlug',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncLeagueCenter { ...props } />
  },
  {
    path: '/lig-merkezi/:mainSlug/:tabSlug',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncLeagueCenter { ...props } />
  },
  {
    path: '/arkadasini-getir',
    // eslint-disable-next-line react/display-name
    render: props => {
      const currentQueryParams = qs.parse(props?.location?.search, { arrayFormat: 'bracket', parseNumbers: true, parseBooleans: true });
      if (currentQueryParams['referans-kod']) {
        return <AsyncInviteFriend { ...props } />;
      }
      return <AsyncInviteFriendAuth { ...props } />;
    },
  },
  {
    path: '/anasayfa-arama',
    render: props => <AsyncVaixSearch { ...props } />
  },
  {
    path: '/kupon-ozet',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncCouponSuccess { ...props } />
  },
  {
    path: '/mail-aydinlatma-metni',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncMailPrivacyPolicy { ...props } />
  },
  {
    path: '/platform-aydinlatma-metni',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncPlatformPrivacyPolicy { ...props } />
  },
  {
    path: '/pending-activation',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncPendingMembershipScreen { ...props } />
  },
  {
    path: '/pending-deposit',
    // eslint-disable-next-line react/display-name
    render: props => <AsyncPendingDepositMoney { ...props } />
  },
  {
    path: '/yetersiz-bakiye',
    exact: true,
    // eslint-disable-next-line react/display-name
    render: props => <AsyncLowBalance { ...props } />
  },
  {
    // eslint-disable-next-line react/display-name
    render: props => <AsyncNotFound { ...props } />
  }
];
